// src/services/authToken.js — auth token storage.
//
// Split out of api.js so the offline outbox can read the token when it drains
// without importing api.js (api.js installs the offline interceptor, which
// imports the outbox — importing back would be a cycle).
//
// Capacitor Preferences on the installed phone app, localStorage on the web.

import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

const isNativePlatform = Capacitor.isNativePlatform();

let cachedToken = null;

export const getAuthToken = async () => {
  if (cachedToken) return cachedToken;

  if (isNativePlatform) {
    const { value } = await Preferences.get({ key: 'authToken' });
    cachedToken = value;
    return value;
  }
  cachedToken = localStorage.getItem('authToken');
  return cachedToken;
};

export const setAuthToken = async (token) => {
  cachedToken = token;
  if (isNativePlatform) {
    await Preferences.set({ key: 'authToken', value: token });
  } else {
    localStorage.setItem('authToken', token);
  }
};

export const removeAuthToken = async () => {
  cachedToken = null;
  if (isNativePlatform) {
    await Preferences.remove({ key: 'authToken' });
  } else {
    localStorage.removeItem('authToken');
  }
};
